import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";
import logo from "../../assets/Logo/myburgoLogo.svg";
import profilePic from "../../assets/profilepicture.png";
import dashboardIcon from "../../assets/Icons/dashboardIcon.svg";
import leads from "../../assets/Icons/leads.svg";
import revenue from "../../assets/Icons/revenue.svg";
import bookingsIcon from "../../assets/Icons/bookingsIcon.svg";
import arrowright from "../../assets/Icons/chevron-right.svg";
import whiteArrow from "../../assets/Icons/rightArrowWhite.svg";
import Button from "../Button/Button";
import Modal from "../Dialog/Modal";
import useAuth from "../../Hooks/useAuth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import couponsidebar from "../../assets/Icons/couponsidebar.svg";
import aiIcon from "../../assets/Icons/aiIcon.svg";
import packageIcon from "../../assets/Icons/packageIcon.svg";
import apiKeyIcon from "../../assets/Icons/apiKeyIcon.svg";
import { ChefHat, ShieldCheck } from "lucide-react";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const [isBookingsOpen, setIsBookingsOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isLeadsOpen, setIsLeadsOpen] = useState(false);
  const [isRevenueOpen, setIsRevenueOpen] = useState(false);
  const [isCouponOpen, setIsCouponOpen] = useState(false);
  const [isAIOpen, setIsAIOpen] = useState(false);
  const [isWorkshopsOpen, setIsWorkshopsOpen] = useState(false);
  const [isRecipesOpen, setIsRecipesOpen] = useState(false);
  const [isAdministrationOpen, setIsAdministrationOpen] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const { logout, isAdmin } = useAuth();
  const [expertName, setExpertName] = useState("");

  // Retrieve the expert name from cookies
  useEffect(() => {
    const nameFromCookies = Cookies.get("userName") || "Guest";
    console.log("Sidebar Debug - userName:", nameFromCookies);
    console.log("Sidebar Debug - expertID:", Cookies.get("expertID"));
    console.log("Sidebar Debug - userId:", Cookies.get("userId"));
    setExpertName(nameFromCookies);
  }, []);

  // Toggle submenu open/close
  const toggleBookingsMenu = () => {
    setIsBookingsOpen(!isBookingsOpen);
  };

  const toggleLeadsMenu = () => {
    setIsLeadsOpen(!isLeadsOpen);
  };

  const togglRevenueMenu = () => {
    setIsRevenueOpen(!isRevenueOpen);
  };

  const toggleSettingsMenu = () => {
    setIsSettingsOpen(!isSettingsOpen);
  };

  const togglCouponMenu = () => {
    setIsCouponOpen(!isCouponOpen);
  };

  const toggleAIMenu = () => {
    setIsAIOpen(!isAIOpen);
  };

  const toggleWorkshopsMenu = () => {
    setIsWorkshopsOpen(!isWorkshopsOpen);
  };

  const toggleRecipesMenu = () => {
    setIsRecipesOpen(!isRecipesOpen);
  };

  const toggleAdministrationMenu = () => {
    setIsAdministrationOpen(!isAdministrationOpen);
  };

  // Function to check if a path is active or matches a sub-route
  const isActive = (path) => {
    return location.pathname === path;
  };

  useEffect(() => {
    if (location.pathname.startsWith("/bookings")) {
      setIsBookingsOpen(true);
    }
    if (location.pathname.startsWith("/ai")) {
      setIsAIOpen(true);
    }
    if (location.pathname.startsWith("/workshops")) {
      setIsWorkshopsOpen(true);
    }
    if (location.pathname.startsWith("/recipes")) {
      setIsRecipesOpen(true);
    }
    if (
      location.pathname.startsWith("/admin/users") ||
      location.pathname.startsWith("/admin/purchases")
    ) {
      setIsAdministrationOpen(true);
    }
  }, [location.pathname]);

  const cancelLogout = () => {
    setShowConfirmModal(false); // Close confirmation modal
  };

  const confirmLogout = () => {
    logout();
    setShowConfirmModal(false); // Close confirmation modal
  };

  const handleLogout = () => {
    setShowConfirmModal(true);
  };

  // Close sidebar when a link is clicked
  const handleLinkClick = () => {
    toggleSidebar();
  };

  return (
    <>
      {/* Mobile toggle button */}
      <button
        className={`close-sidebar ${isOpen ? "open" : ""}`}
        onClick={toggleSidebar}
      >
        &times;
      </button>

      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        {/* Logo Section */}
        <div className="logo-section">
          <img src={logo} alt="Logo" className="logo" />
        </div>

        {/* Menu Options */}
        <nav className="menu">
          <ul>
            <li
              className={isActive("/") ? "active" : ""}
              onClick={handleLinkClick}
            >
              <Link to="/">
                <span className="icon">
                  <img src={dashboardIcon} alt="Dashboard Icon" />
                </span>
                Dashboard
                <span className="arrow">
                  <img src={arrowright} alt="arrow right" />
                </span>
              </Link>
            </li>

            {!isAdmin && (
              <li
                className={`${
                  isActive("/bookings") || isBookingsOpen ? "open" : ""
                }`}
              >
                <div className="menu-item" onClick={toggleBookingsMenu}>
                  <span className="icon">
                    <img src={bookingsIcon} alt="Bookings Icon" />
                  </span>
                  1 on 1 Bookings
                  <span className={`arrow ${isBookingsOpen ? "open" : ""}`}>
                    <img src={arrowright} alt="arrow right" />
                  </span>
                </div>
                {(isBookingsOpen || isActive("/bookings")) && (
                  <ul className="submenu">
                    <li
                      className={
                        isActive("/bookings/dashboard") ? "active" : ""
                      }
                      onClick={handleLinkClick}
                    >
                      <Link to="/bookings/dashboard">
                        Dashboard
                        <span
                          className={
                            isActive("/bookings/dashboard") ? "show" : "hide"
                          }
                        >
                          <img src={whiteArrow} alt="arrow right" />
                        </span>
                      </Link>
                    </li>
                    <li
                      className={isActive("/bookings/all") ? "active" : ""}
                      onClick={handleLinkClick}
                    >
                      <Link to="/bookings/all">
                        All Bookings
                        <span
                          className={
                            isActive("/bookings/all") ? "show" : "hide"
                          }
                        >
                          <img src={whiteArrow} alt="arrow right" />
                        </span>
                      </Link>
                    </li>
                    <li
                      className={isActive("/bookings/packages") ? "active" : ""}
                      onClick={handleLinkClick}
                    >
                      <Link to="/bookings/packages">
                        Add Packages
                        <span
                          className={
                            isActive("/bookings/packages") ? "show" : "hide"
                          }
                        >
                          <img src={whiteArrow} alt="arrow right" />
                        </span>
                      </Link>
                    </li>
                    <li
                      className={isActive("/bookings/slots") ? "active" : ""}
                      onClick={handleLinkClick}
                    >
                      <Link to="/bookings/slots">
                        Add Slots
                        <span
                          className={
                            isActive("/bookings/slots") ? "show" : "hide"
                          }
                        >
                          <img src={whiteArrow} alt="arrow right" />
                        </span>
                      </Link>
                    </li>
                    <li
                      className={
                        isActive("/bookings/questions") ? "active" : ""
                      }
                      onClick={handleLinkClick}
                    >
                      <Link to="/bookings/questions">
                        Add Registration Questions
                        <span
                          className={
                            isActive("/bookings/questions") ? "show" : "hide"
                          }
                        >
                          <img src={whiteArrow} alt="arrow right" />
                        </span>
                      </Link>
                    </li>
                    <li
                      className={isActive("/bookings/settings") ? "active" : ""}
                      onClick={handleLinkClick}
                    >
                      <Link to="/bookings/settings">
                        Settings
                        <span
                          className={
                            isActive("/bookings/settings") ? "show" : "hide"
                          }
                        >
                          <img src={whiteArrow} alt="arrow right" />
                        </span>
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
            )}
            {isAdmin && (
              <>
                <li
                  className={`admin-navigation ${
                    location.pathname.startsWith("/admin/users") ||
                    location.pathname.startsWith("/admin/purchases") ||
                    isAdministrationOpen
                      ? "open"
                      : ""
                  }`}
                >
                  <div className="menu-item" onClick={toggleAdministrationMenu}>
                    <span className="icon sidebar-lucide-icon">
                      <ShieldCheck aria-hidden="true" />
                    </span>
                    Administration
                    <span
                      className={`arrow ${isAdministrationOpen ? "open" : ""}`}
                    >
                      <img src={arrowright} alt="arrow right" />
                    </span>
                  </div>
                  {(isAdministrationOpen ||
                    location.pathname.startsWith("/admin/users") ||
                    location.pathname.startsWith("/admin/purchases")) && (
                    <ul className="submenu">
                      <li
                        className={isActive("/admin/users") ? "active" : ""}
                        onClick={handleLinkClick}
                      >
                        <Link to="/admin/users">
                          Users
                          <span
                            className={
                              isActive("/admin/users") ? "show" : "hide"
                            }
                          >
                            <img src={whiteArrow} alt="arrow right" />
                          </span>
                        </Link>
                      </li>
                      <li
                        className={
                          isActive("/admin/purchases") ? "active" : ""
                        }
                        onClick={handleLinkClick}
                      >
                        <Link to="/admin/purchases">
                          Purchases
                          <span
                            className={
                              isActive("/admin/purchases") ? "show" : "hide"
                            }
                          >
                            <img src={whiteArrow} alt="arrow right" />
                          </span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li
                  className={`${
                    location.pathname.startsWith("/workshops") || isWorkshopsOpen
                      ? "open"
                      : ""
                  }`}
                >
                  <div className="menu-item" onClick={toggleWorkshopsMenu}>
                    <span className="icon">
                      <img src={packageIcon} alt="Workshops Icon" />
                    </span>
                    Workshops
                    <span className={`arrow ${isWorkshopsOpen ? "open" : ""}`}>
                      <img src={arrowright} alt="arrow right" />
                    </span>
                  </div>
                  {(isWorkshopsOpen ||
                    location.pathname.startsWith("/workshops")) && (
                    <ul className="submenu">
                      <li
                        className={isActive("/workshops") ? "active" : ""}
                        onClick={handleLinkClick}
                      >
                        <Link to="/workshops">
                          All Workshops
                          <span
                            className={
                              isActive("/workshops") ? "show" : "hide"
                            }
                          >
                            <img src={whiteArrow} alt="arrow right" />
                          </span>
                        </Link>
                      </li>
                      <li
                        className={
                          isActive("/workshops/new") ? "active" : ""
                        }
                        onClick={handleLinkClick}
                      >
                        <Link to="/workshops/new">
                          Create Workshop
                          <span
                            className={
                              isActive("/workshops/new") ? "show" : "hide"
                            }
                          >
                            <img src={whiteArrow} alt="arrow right" />
                          </span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li
                  className={`${
                    location.pathname.startsWith("/recipes") || isRecipesOpen
                      ? "open"
                      : ""
                  }`}
                >
                  <div className="menu-item" onClick={toggleRecipesMenu}>
                    <span className="icon sidebar-lucide-icon">
                      <ChefHat aria-hidden="true" />
                    </span>
                    Recipes
                    <span className={`arrow ${isRecipesOpen ? "open" : ""}`}>
                      <img src={arrowright} alt="arrow right" />
                    </span>
                  </div>
                  {(isRecipesOpen ||
                    location.pathname.startsWith("/recipes")) && (
                    <ul className="submenu">
                      <li
                        className={isActive("/recipes") ? "active" : ""}
                        onClick={handleLinkClick}
                      >
                        <Link to="/recipes">
                          All Recipes
                          <span
                            className={
                              isActive("/recipes") ? "show" : "hide"
                            }
                          >
                            <img src={whiteArrow} alt="arrow right" />
                          </span>
                        </Link>
                      </li>
                      <li
                        className={isActive("/recipes/new") ? "active" : ""}
                        onClick={handleLinkClick}
                      >
                        <Link to="/recipes/new">
                          Add Recipe
                          <span
                            className={
                              isActive("/recipes/new") ? "show" : "hide"
                            }
                          >
                            <img src={whiteArrow} alt="arrow right" />
                          </span>
                        </Link>
                      </li>
                      <li
                        className={
                          location.pathname.startsWith("/recipes/setup")
                            ? "active"
                            : ""
                        }
                        onClick={handleLinkClick}
                      >
                        <Link to="/recipes/setup">
                          Setup & Engagement
                          <span
                            className={
                              location.pathname.startsWith("/recipes/setup")
                                ? "show"
                                : "hide"
                            }
                          >
                            <img src={whiteArrow} alt="arrow right" />
                          </span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li
                  className={isActive("/payout") ? "active" : ""}
                  onClick={handleLinkClick}
                >
                  <Link to="/payout">
                    <span className="icon">
                      <img src={revenue} alt="Dashboard Icon" />
                    </span>
                    Payout
                    <span className="arrow">
                      <img src={arrowright} alt="arrow right" />
                    </span>
                  </Link>
                </li>
                <li
                  className={isActive("/admin/settings") ? "active" : ""}
                  onClick={handleLinkClick}
                >
                  <Link to="/admin/settings">
                    <span className="icon">
                      <img src={revenue} alt="Dashboard Icon" />
                    </span>
                    Settings
                    <span className="arrow">
                      <img src={arrowright} alt="arrow right" />
                    </span>
                  </Link>
                </li>
                <li
                  className={isActive("/api-keys") ? "active" : ""}
                  onClick={handleLinkClick}
                >
                  <Link to="/api-keys">
                    <span className="icon">
                      <img src={apiKeyIcon} alt="API Keys Icon" />
                    </span>
                    API Keys
                    <span className="arrow">
                      <img src={arrowright} alt="arrow right" />
                    </span>
                  </Link>
                </li>
                <li
                  className={`${
                    isActive("/ai") || isAIOpen ? "open" : ""
                  }`}
                >
                  <div className="menu-item" onClick={toggleAIMenu}>
                    <span className="icon">
                      <img src={aiIcon} alt="AI Icon" />
                    </span>
                    AI Analytics
                    <span className={`arrow ${isAIOpen ? "open" : ""}`}>
                      <img src={arrowright} alt="arrow right" />
                    </span>
                  </div>
                  {(isAIOpen || isActive("/ai")) && (
                    <ul className="submenu">
                      <li
                        className={isActive("/ai/dashboard") ? "active" : ""}
                        onClick={handleLinkClick}
                      >
                        <Link to="/ai/dashboard">
                          Dashboard
                          <span
                            className={
                              isActive("/ai/dashboard") ? "show" : "hide"
                            }
                          >
                            <img src={whiteArrow} alt="arrow right" />
                          </span>
                        </Link>
                      </li>
                      <li
                        className={isActive("/ai/sessions") ? "active" : ""}
                        onClick={handleLinkClick}
                      >
                        <Link to="/ai/sessions">
                          Sessions
                          <span
                            className={
                              isActive("/ai/sessions") ? "show" : "hide"
                            }
                          >
                            <img src={whiteArrow} alt="arrow right" />
                          </span>
                        </Link>
                      </li>
                      <li
                        className={isActive("/ai/usage") ? "active" : ""}
                        onClick={handleLinkClick}
                      >
                        <Link to="/ai/usage">
                          Usage & Costs
                          <span
                            className={
                              isActive("/ai/usage") ? "show" : "hide"
                            }
                          >
                            <img src={whiteArrow} alt="arrow right" />
                          </span>
                        </Link>
                      </li>
                      <li
                        className={isActive("/ai/feedback") ? "active" : ""}
                        onClick={handleLinkClick}
                      >
                        <Link to="/ai/feedback">
                          Feedback
                          <span
                            className={
                              isActive("/ai/feedback") ? "show" : "hide"
                            }
                          >
                            <img src={whiteArrow} alt="arrow right" />
                          </span>
                        </Link>
                      </li>
                      <li
                        className={isActive("/ai/playground") ? "active" : ""}
                        onClick={handleLinkClick}
                      >
                        <Link to="/ai/playground">
                          Prompt Playground
                          <span
                            className={
                              isActive("/ai/playground") ? "show" : "hide"
                            }
                          >
                            <img src={whiteArrow} alt="arrow right" />
                          </span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
              </>
            )}

            {/* <li
              className={`${
                isActive("/leads") || isLeadsOpen ? "open" : ""
              }`}
            >
              <div className="menu-item" onClick={toggleLeadsMenu}>
                <span className="icon">
                  <img src={leads} alt="Bookings Icon" />
                </span>
                Leads
                <span className={`arrow ${isLeadsOpen ? "open" : ""}`}>
                  <img src={arrowright} alt="arrow right" />
                </span>
              </div>
              {(isLeadsOpen || isActive("/leads")) && (
                <ul className="submenu">
                  <li
                    className={isActive("/leads/dashboard") ? "active" : ""}
                    onClick={handleLinkClick}
                  >
                    <Link to="/leads/dashboard">Leads Dashboard
                    <span className={isActive("/leads/dashboard")? "show" : "hide"}>
                      <img src={whiteArrow} alt="arrow right"/>
                    </span>
                    </Link>
                    
                  </li>
                  <li
                    className={isActive("/leads/all") ? "active" : ""}
                    onClick={handleLinkClick}
                  >
                    <Link to="/leads/all">
                    All leads
                    <span className={isActive("/leads/all") ? "show" : "hide"}>
                      <img src={whiteArrow} alt="arrow right"/>
                    </span>
                    </Link>
                  </li>
                  <li
                    className={isActive("/leads/leadscapture") ? "active" : ""}
                    onClick={handleLinkClick}
                  >
                    <Link to="/leads/leadscapture">
                    Leads Capture
                    <span className={isActive("/leads/leadscapture")? "show" : "hide" }>
                      <img src={whiteArrow} alt="arrow right"/>
                    </span>
                    </Link>
                  </li>
                  
                 
                </ul>
              )}
            </li> */}
            {!isAdmin && (
              <li
                className={`${
                  isActive("/revenue") || isRevenueOpen ? "open" : ""
                }`}
              >
                <div className="menu-item" onClick={togglRevenueMenu}>
                  <span className="icon">
                    <img src={revenue} alt="Bookings Icon" />
                  </span>
                  Revenue
                  <span className={`arrow ${isRevenueOpen ? "open" : ""}`}>
                    <img src={arrowright} alt="arrow right" />
                  </span>
                </div>
                {(isRevenueOpen || isActive("/revenue")) && (
                  <ul className="submenu">
                    <li
                      className={isActive("/revenue/dashboard") ? "active" : ""}
                      onClick={handleLinkClick}
                    >
                      <Link to="/revenue/dashboard">
                        Dashboard
                        <span
                          className={
                            isActive("/revenue/dashboard") ? "show" : "hide"
                          }
                        >
                          <img src={whiteArrow} alt="arrow right" />
                        </span>
                      </Link>
                    </li>
                    <li
                      className={isActive("/revenue/all") ? "active" : ""}
                      onClick={handleLinkClick}
                    >
                      <Link to="/revenue/all">
                        All Transcations
                        <span
                          className={isActive("/revenue/all") ? "show" : "hide"}
                        >
                          <img src={whiteArrow} alt="arrow right" />
                        </span>
                      </Link>
                    </li>
                    {/* <li
                    className={isActive("/revenue/payouts") ? "active" : ""}
                    onClick={handleLinkClick}
                  >
                    <Link to="/revenue/payouts">
                    Payouts
                    <span className={isActive("/revenue/payouts")? "show" : "hide" }>
                      <img src={whiteArrow} alt="arrow right"/>
                    </span>
                    </Link>
                  </li> */}
                  </ul>
                )}
              </li>
            )}

            {/* <li
              className={`${
                isActive("/coupon") || isCouponOpen ? "open" : ""
              }`}
            >
              <div className="menu-item" onClick={togglCouponMenu}>
                <span className="icon">
                  <img src={couponsidebar} alt="Bookings Icon" />
                </span>
                Coupon
                <span className={`arrow ${isCouponOpen ? "open" : ""}`}>
                  <img src={arrowright} alt="arrow right" />
                </span>
              </div>
              {(isCouponOpen || isActive("/coupon")) && (
                <ul className="submenu">
                  <li
                    className={isActive("/coupon/bookings") ? "active" : ""}
                    onClick={handleLinkClick}
                  >
                    <Link to="/coupon/bookings">Bookings
                    <span className={isActive("/coupon/bookings")? "show" : "hide"}>
                      <img src={whiteArrow} alt="arrow right"/>
                    </span>
                    </Link>
                    
                  </li>
                  <li
                    className={isActive("/coupon/workshop") ? "active" : ""}
                    onClick={handleLinkClick}
                  >
                    <Link to="/coupon/workshop">
                    Workshop
                    <span className={isActive("/coupon/workshop") ? "show" : "hide"}>
                      <img src={whiteArrow} alt="arrow right"/>
                    </span>
                    </Link>
                  </li>
                  
                 
                </ul>
              )}
            </li> */}
          </ul>
        </nav>

        {/* Profile Section */}
        <div className="profile-section">
          <FontAwesomeIcon icon={faUser} className="profile-pic" />
          <div className="profile-info">
            <p className="name">{expertName}</p>
            {/* <p className="title">Self care expert</p> */}
          </div>
        </div>
        <Button
          text="Logout"
          marginBottom="20%"
          backgroundColor="#D11A2A"
          onClick={handleLogout}
        />
        {showConfirmModal && (
          <Modal
            title="Confirm Logout"
            onClose={cancelLogout} // Close modal on cancel
          >
            <div>Are you sure you want to Logout?</div>
            <div className="confirmation-buttons">
              <Button
                text="cancel"
                backgroundColor="#ccc"
                onClick={cancelLogout}
              ></Button>
              <Button
                text="Logout"
                backgroundColor="#D11A2A "
                onClick={confirmLogout}
              ></Button>
            </div>
          </Modal>
        )}
      </div>
    </>
  );
};

export default Sidebar;
